module.exports = __webpack_public_path__ + "img/yacht-v1.fe9487b9.jpg";